import { render, staticRenderFns } from "./AssignedQuestions.vue?vue&type=template&id=3f0d24b0"
import script from "./AssignedQuestions.vue?vue&type=script&lang=js"
export * from "./AssignedQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports